import { render, staticRenderFns } from "./interventions-tabs.vue?vue&type=template&id=cada473a&scoped=true&"
import script from "./interventions-tabs.vue?vue&type=script&lang=js&"
export * from "./interventions-tabs.vue?vue&type=script&lang=js&"
import style0 from "./interventions-tabs.vue?vue&type=style&index=0&id=cada473a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cada473a",
  null
  
)

export default component.exports